import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "@apollo/client";
const GET_ROOT_CATEGORY_ID = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query getRootCategoryId {\n        storeConfig {\n            id\n            root_category_id\n        }\n    }\n"])));
export default {
  getRootCategoryId: GET_ROOT_CATEGORY_ID
};